(function () {
  const DRAWER_SELECTOR = '#upCart';
  const LINE_CLASS = 'cart-drawer-line';
  const ROOT = window.Shopify?.routes?.root || '/';

  let shadowObserver = null;
  let activeRoot = null;
  let timer = null;
  let loading = false;
  let pending = false;

  function productPath(url) {
    try {
      const path = new URL(url, location.origin).pathname;
      const match = path.match(/\/products\/([^/]+)/);
      return match ? match[1] : null;
    } catch {
      return null;
    }
  }

  function findProductRow(link) {
    let element = link.parentElement;

    while (element && element.id !== 'CartPopup') {
      const className =
        typeof element.className === 'string' ? element.className : '';

      if (/ProductRow|CartItem|LineItem|cart-item|product-row/i.test(className)) {
        return element;
      }

      element = element.parentElement;
    }

    return null;
  }

  // _demo ko checkout wali visible property "Details" me copy karta hai
  async function syncDetails(cart) {
    let changed = false;

    for (const item of cart.items) {
      const props = item.properties || {};

      if (props._demo && !props.Details) {
        try {
          await fetch(`${ROOT}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: { ...props, Details: props._demo }
            })
          });
          changed = true;
        } catch (e) {
          console.error('Details sync error:', e);
        }
      }
    }

    return changed;
  }

  async function updateUpcart() {
    if (loading) {
      pending = true;
      return;
    }

    const root = document.querySelector(DRAWER_SELECTOR)?.shadowRoot;
    if (!root) return;

    loading = true;

    try {
      const response = await fetch(`${ROOT}cart.js`, { cache: 'no-store' });
      if (!response.ok) return;

      let cart = await response.json();

      if (await syncDetails(cart)) {
        const fresh = await fetch(`${ROOT}cart.js`, { cache: 'no-store' });
        if (fresh.ok) cart = await fresh.json();
      }

      const links = [...root.querySelectorAll('a[href*="/products/"]')];
      const processed = new Set();

      links.forEach(link => {
        const handle = productPath(link.href);
        if (!handle) return;

        const row = findProductRow(link);
        if (!row || processed.has(row)) return;

        processed.add(row);

        const matches = cart.items.filter(item => item.handle === handle);
        const existing = row.querySelector(`.${LINE_CLASS}`);

        if (matches.length !== 1) {
          existing?.remove();
          return;
        }

        const props = matches[0].properties || {};
        const value = props._demo || props.Details;

        if (!value) {
          existing?.remove();
          return;
        }

        let line = existing;

        if (!line) {
          line = document.createElement('div');
          line.className = LINE_CLASS;
          row.appendChild(line);
        }

        if (line.textContent !== String(value)) {
          line.textContent = String(value);
        }
      });
    } catch (error) {
      console.error('Upcart metafield error:', error);
    } finally {
      loading = false;

      if (pending) {
        pending = false;
        scheduleUpdate();
      }
    }
  }

  function scheduleUpdate() {
    clearTimeout(timer);
    timer = setTimeout(updateUpcart, 200);
  }

  function initUpcart() {
    const root = document.querySelector(DRAWER_SELECTOR)?.shadowRoot;
    if (!root || root === activeRoot) return;

    shadowObserver?.disconnect();
    activeRoot = root;

    shadowObserver = new MutationObserver(scheduleUpdate);
    shadowObserver.observe(root, { childList: true, subtree: true });

    scheduleUpdate();
  }

  new MutationObserver(initUpcart).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('click', scheduleUpdate);

  if (typeof window.upcartSubscribeCartLoaded === 'function') {
    window.upcartSubscribeCartLoaded(scheduleUpdate);
  }

  initUpcart();
})();